<template>
  <ServiceSeoContent v-if="service" :service="service" variant="hidden" />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import ServiceSeoContent from '@/components/seo/ServiceSeoContent.vue';
import { useServiceSeo } from '@/composables/useServiceSeo';

const { service, queryServiceId, resolveById, applyService, clearService } = useServiceSeo();

const hasServiceParam = computed(() => queryServiceId.value !== null);

watch(
  hasServiceParam,
  async (present, wasPresent) => {
    if (present && queryServiceId.value !== null) {
      const resolved = await resolveById(queryServiceId.value);
      if (resolved) await applyService(resolved);
    } else if (wasPresent) {
      clearService();
    }
  },
  { immediate: true },
);
</script>
